import { createElementBlock as t, openBlock as e, createElementVNode as r } from "vue";
import n from "./index289.js";
const l = {}, s = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function a(c, o, p, f, i, m) {
  return e(), t("svg", s, o[0] || (o[0] = [
    r("path", {
      fill: "currentColor",
      d: "M5.47 8.47a.75.75 0 0 1 .976-.073l.084.073L12 13.939l5.47-5.47a.75.75 0 0 1 .976-.072l.084.073a.75.75 0 0 1 .073.976l-.073.084-6 6a.75.75 0 0 1-.976.073l-.084-.073-6-6a.75.75 0 0 1 0-1.06Z"
    }, null, -1)
  ]));
}
const u = /* @__PURE__ */ n(l, [["render", a]]);
export {
  u as default
};
